import React, { useState, useEffect } from 'react';
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
  getDetails,
} from "use-places-autocomplete";
import useOnclickOutside from "react-cool-onclickoutside";

import styled from "react-emotion";

const Input = styled("input")`
  font-size: 16px;
  width: 100%;
  padding: 11px 15px 11px 8px;
  animation: 1ms void-animation-out;
  margin-bottom: 20px;
`;

const CList = styled("ul")`
  list-style: none;
  position: absolute;
  background: white;
  margin-top: -21px;
  z-index: 10;
`;

const CListItem = styled("li")`
  margin: 5px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

const MAPS_KEY_STREET_NUM = "street_number";
const MAPS_KEY_STREET_NAME = "route";
const MAPS_KEY_APT_SUITE = "subpremise";
const MAPS_KEY_CITY = "locality";
const MAPS_KEY_COUNTY = "administrative_area_level_2";
const MAPS_KEY_STATE = "administrative_area_level_1";
const MAPS_KEY_ZIP_CODE = "postal_code";
const MAPS_KEY_COUNTRY = "country";

const SearchLocationInput = (props) => {
  const { tempAddress, setTempAddress } = props;

  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({
    requestOptions: {
      /* Define search scope here */
    },
    debounce: 300,
  });

  const ref = useOnclickOutside(() => {
    // When user clicks outside of the component, we can dismiss
    // the searched suggestions by calling this method
    clearSuggestions();
  });

  const handleInput = (e) => {
    // Update the keyword of the input element
    setValue(e.target.value);
  };

  const handleSelect =
    ({ description }) =>
    () => {
      // When user selects a place, we can replace the keyword without request data from API
      // by setting the second parameter to "false"
      setValue(description, false);
      clearSuggestions();

      var streetNum = null;
      var streetName = null;
      var city = null;
      var county = null;
      var state = null;
      var zipCode = null;
      var country = null;
      var latitude = null;
      var longitude = null;

      // Get latitude and longitude via utility functions
      getGeocode({ address: description })
        .then((results) => {
          // console.log("got results...");
          // console.log(results[0].place_id);
          // console.dir(results[0].address_components);
          Object.assign(tempAddress, {
            googlePlacesId: results[0].place_id,
          });

          // const MAPS_KEY_COUNTRY = "country";

          results[0].address_components.map((component) => {
            // console.log("printing component...");
            // console.dir(component);
            // console.log(typeof component.types);

            if (component.types.includes(MAPS_KEY_STREET_NUM)) {
              // console.log("2222 found street_number type!");
              streetNum = component.short_name;
            } else if (component.types.includes(MAPS_KEY_STREET_NAME)) {
              streetName = component.short_name;
            } else if (component.types.includes(MAPS_KEY_CITY)) {
              city = component.short_name;
            } else if (component.types.includes(MAPS_KEY_COUNTY)) {
              county = component.short_name;
            } else if (component.types.includes(MAPS_KEY_STATE)) {
              state = component.short_name;
            } else if (component.types.includes(MAPS_KEY_ZIP_CODE)) {
              zipCode = component.short_name;
            } else if (component.types.includes(MAPS_KEY_COUNTRY)) {
              country = component.short_name;
            }
          });

          // console.log(streetName);
          // console.log(streetNum);
          // console.log(city);
          // console.log(county);
          // console.log(state);
          // console.log(zipCode);
          // console.log(country);

          // setTempAddress({
          //   ...tempAddress,
          //   googlePlacesId: results[0].place_id,
          // });

          return getLatLng(results[0]);
        })
        .then(({ lat, lng }) => {
          latitude = lat;
          longitude = lng;
          // setTempAddress({ ...tempAddress, latitude: lat, longitude: lng });
          // console.log("📍 Coordinates: ", { latitude, longitude });
        })
        .then(() => {
          setTempAddress({
            ...tempAddress,
            streetAddress: streetNum + " " + streetName,
            city,
            state,
            zip: zipCode,
            latitude,
            longitude,
          });
        })
        .catch((error) => {
          console.log("😱 Error: ", error);
        });
    };

  const renderSuggestions = () =>
    data.map((suggestion) => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text },
      } = suggestion;

      return (
        <CListItem key={place_id} onClick={handleSelect(suggestion)}>
          <strong>{main_text}</strong> <small>{secondary_text}</small>
        </CListItem>
      );
    });

  return (
    <div ref={ref}>
      <Input
        value={value}
        onChange={handleInput}
        disabled={!ready}
        placeholder="Enter a new address"
      />
      {/* We can use the "status" to decide whether we should display the dropdown or not */}
      {status === "OK" && <CList>{renderSuggestions()}</CList>}
    </div>
  );
};

export default SearchLocationInput;
